var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.4,
    height: 12.4,
    viewBox: "0 0 12.4 12.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_77198",
    "data-name": "Group 77198",
    transform: "translate(18393.928 -7537.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M22.4,36a6,6,0,1,0-6-6A6.007,6.007,0,0,0,22.4,36Zm0-11.155A5.155,5.155,0,1,1,17.245,30,5.163,5.163,0,0,1,22.4,24.845Z",
    transform: "translate(-18410.127 7514)",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M42.326,44.823c.285,0,.526-.151.526-.329V40.229c0-.178-.241-.329-.526-.329s-.526.151-.526.329v4.265C41.8,44.672,42.041,44.823,42.326,44.823Z",
    transform: "translate(-18431.141 7501.584)",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M54.926,44.823c.285,0,.526-.151.526-.329V40.229c0-.178-.241-.329-.526-.329s-.526.151-.526.329v4.265C54.4,44.672,54.619,44.823,54.926,44.823Z",
    transform: "translate(-18441.564 7501.584)",
    stroke: "#000",
    strokeWidth: 0.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.b93831bd13bf2c586362b6a8556983ea.svg";
export { ForwardRef as ReactComponent };